<router-outlet></router-outlet>

@if (loaderApp$ | async) {
<section class="loader">
  <app-loader></app-loader>
</section>
}

<core-ui-toast></core-ui-toast>
<core-ui-flash-toast></core-ui-flash-toast>
